module.exports = __webpack_public_path__ + "img/TL.f0649357.svg";